import angular from 'angular'

/**
 * A header element. Can specify the category to style the header in a particular way.
 *
 * @role headings
 */
angular.module('vend.ui').directive('vdHeader', function (elementService) {
  return {
    link(scope, $element, attrs) {
      const classes = elementService.getClasses($element)
      const category = attrs.category || 'section'

      classes.push('vd-header')
      classes.push(`vd-header--${category}`)

      attrs.$set('role', 'headings')
      attrs.$set('class', classes.join(' '))
    },
  }
})
